module.exports = __webpack_public_path__ + "media/images/icon_nav_month_white-ed4b95ba024c01433da44cc8e0111a4b.svg";